'use client';

import React from 'react';
import BlogSmallCard from '../blogSmallCard/BlogSmallCard';
import Image from 'next/image';
import Ad1 from '@/public/homePage/BlogSideBar/ad small@3x.webp';
import Ad2 from '@/public/homePage/BlogSideBar/ad small@3x copy.webp';
import { HeadingText } from '@/components/DynamicText';
import { NoDataFound } from '@/components/NoData';
import dynamic from 'next/dynamic';
const Form = dynamic(() => import('@/components/Form'), { ssr: false });

function BlogSideBar(props: any) {
  const { topPick, recent } = props;
  const show = process.env.NEXT_PUBLIC_PLATFORM === 'mykare-blog';
  return (
    <>
      {/* toppicks */}
      <HeadingText className=' mb-[20px] font-medium tracking-[-.36px] text-[#1c2534] dark:text-white'>
        Top Picks
      </HeadingText>
      {topPick?.length ? (
        topPick?.map((item: any) => (
          <BlogSmallCard key={item.id} data={item} btnName='Read Article' />
        ))
      ) : (
        <NoDataFound />
      )}

      {/* ads 1 */}
      {show && <Image className='my-[30px]' src={Ad1} alt='ads'></Image>}

      {/* Recently saved */}
      <HeadingText className=' mb-[20px] text-[18px] font-medium tracking-[-.36px] text-[#1c2534] dark:text-white'>
        Recently Saved
      </HeadingText>
      {recent?.length ? (
        recent
          ?.reverse()
          ?.slice(0, 3)
          ?.map((item: any) => (
            <BlogSmallCard key={item.id} data={item} btnName='Read Article' />
          ))
      ) : (
        <NoDataFound />
      )}
      {/* ads 2 */}
      {show && <Image className='my-[30px]' src={Ad2} alt='ads' />}

      {/* <h3 className='mb-[20px] text-[18px] text-[#1c2534] tracking-[-.36px] font-medium 
        '> Who to Follow</h3>
        {recent.map((item:object)=>(
          <BlogSmallCard data ={item} btnName = "Read Article"/>
        ))} */}
      {/* form  */}
      <Form />
    </>
  );
}

export default BlogSideBar;
